import * as React from "react";
import FileDropHandler from "./FileDropHandler";
import { IconUploadCloud } from "@velaro/velaro-component-lib";

interface Props {
  onAddFiles(files: File[]): void;
  multiple?: boolean;
  children?: React.ReactNode;
  accept?: string;
}

export default function FileUpload({
  onAddFiles,
  children,
  multiple,
  accept = ""
}: Props) {
  const fileInputRef = React.useRef<HTMLInputElement>(null);

  function onDrop(newFiles: File[]) {
    if (multiple) {
      onAddFiles(newFiles);
    } else {
      onAddFiles([newFiles[0]]);
    }
  }

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        multiple={!!multiple}
        accept={accept}
        style={{ display: "none" }}
        onChange={(e) => {
          const fileList = e.currentTarget.files;

          if (!fileList) {
            return;
          }

          const files: File[] = [];

          for (let i = 0; i < fileList.length; i++) {
            files.push(fileList[i]);
          }

          onDrop(files);
        }}
      />
      <div
        className="p-4 bg-slate-50 border-2 border-dashed border-slate-300 rounded-lg cursor-pointer relative"
        onClick={() => {
          const fileInput = fileInputRef.current;
          if (!fileInput) {
            return;
          }
          fileInput.value = ""; // Clear previous selection
          fileInput.click();
        }}
      >
        <div className="flex flex-col items-center justify-center">
          <IconUploadCloud />
          <div className="text-slate-500 text-sm">
            Drag and drop {multiple ? "files" : "your file"} here or
            <b> click</b> to browse
          </div>
          {children}
        </div>
        <div>
          <FileDropHandler onDrop={onDrop} />
        </div>
      </div>
    </>
  );
}
